import { createVanIconComponent } from "./van"

const BackTop = createVanIconComponent("back-top")
export default BackTop
